import { Component, Input, ViewChild } from '@angular/core';

import { AuthService } from '../../../../../providers/auth.service';
import { SharedHackService } from '../../../shared/services/shared-hack.service';
import { ScreenTalentService } from '../../screen-talent.service';
import { SharedClientService } from '../../../shared/services/shared-client.service';
import { Observable } from 'rxjs/Observable';
import { default as swal } from 'sweetalert2';
import { TagifyComponent } from './tagify.component';

declare var $: any;


export class InviteCandidateComponent {
	 public tagifyCmp: TagifyComponent;

	 public test: any;

	public emailInvitation: any = {};
	public generatingTestLink = false;
	public generatingBulkTestLink = false;
	public bulkInvitationsActive = false;
	public bulkEmails: string[] = [];
	public bulkEmailsFailedToSend: string[] = [];
	public bulkSendingEmailProgress = 0;
	public bulkSendingEmailProgressStep = 0;
	public bulkInvitationsSendingStarted = false;
	public bulkInvitationsSendingInProgress = false;

	constructor(
		private authService: AuthService,
		private sharedHackService: SharedHackService,
		private screenTalentService: ScreenTalentService,
		private clientService: SharedClientService) { }

	// Events
	public bulkEmailsChange(emails: string[]) {
		this.bulkEmails = emails;
	}

	public onCopyLinkClick(): void {
		$('#invite-test-link').select();
		document.execCommand('copy');
	}

	public onGenerateTestLinkClick(): void {
		this.generatingTestLink = true;
		this.clientService.get(this.authService.userId).subscribe(
			(client) => {
				this.sharedHackService.postExternalTestsInvitation(String(this.authService.userId), this.test.id, {}).subscribe(
					(testLink) => {
						this.generatingTestLink = false;

						if (testLink && testLink.url) {
							this.emailInvitation['testLink'] = testLink.url;
							this.emailInvitation['inviteId'] = testLink.id;
							this.setEmailTemplate(client);
							this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'candidateInvited', data: false });
						}
					},
					(err) => {
						this.generatingTestLink = false;
					}
				);
			}
		);
	}

	public generatingBulkEmailTemplate() {
		this.generatingBulkTestLink = true;
		this.clientService.get(this.authService.userId).subscribe(
			(client) => {
				this.bulkInvitationsActive = true;
				this.generatingBulkTestLink = false;
				this.setEmailTemplate(client);
			}
		);
	}

	public onInviteTestFormSubmit(): void {
		if (this.bulkInvitationsActive) {
			this.onBulkInviteTestFormSubmit();
			return;
		}

		const candidateFullNameParts = this.emailInvitation.full_name.split(' ');
		this.emailInvitation.message =  replaceAll(this.emailInvitation.message, '{{invitation_link}}', this.emailInvitation.testLink);
		let data = {
			full_name: this.emailInvitation.full_name,
			invited_email: this.emailInvitation.email,
			subject: replaceAll(replaceAll(this.emailInvitation.subject, '{{candidate_first_name}}', candidateFullNameParts[0]), '{{candidate_last_name}}', candidateFullNameParts[1] ? candidateFullNameParts[1] : ''),
			message: replaceAll(replaceAll(this.emailInvitation.message, '{{candidate_first_name}}', candidateFullNameParts[0]), '{{candidate_last_name}}', candidateFullNameParts[1] ? candidateFullNameParts[1] : '')
		};
		this.sharedHackService.postExternalTestsInvitationNotification(String(this.authService.userId), this.emailInvitation.inviteId, data).subscribe(
			(resp) => {
				this.emailInvitation['success'] = true;
				setTimeout(() => {
					this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'changeView', data: 'summary' });
				}, 3000);
			}
		);
	}

	public onBulkInviteTestFormSubmit() {
		const bulkObs = [];
		this.bulkEmailsFailedToSend = [];
		this.bulkSendingEmailProgress = 0;
		this.bulkInvitationsSendingInProgress = true;
		this.bulkInvitationsSendingStarted = true;
		let data = {
			invited_email: '',
			subject: replaceAll(this.emailInvitation['subject'], '{{candidate_first_name}}', ''),
			message: replaceAll(this.emailInvitation['message'], '{{candidate_first_name}}', ''),
		};
		this.bulkEmails.forEach((email) => {
			bulkObs.push(this.createAndSendBulkTestLink({
				...data,
				invited_email: email
			}));
		});
		this.bulkSendingEmailProgressStep = 100 / this.bulkEmails.length;

		Observable.from(bulkObs)
			.concatMap((obs) => obs).subscribe(
				(_) => this.bulkSendingEmailProgress += this.bulkSendingEmailProgressStep,
				(_) => undefined,
				() => {
					if (!this.bulkEmailsFailedToSend.length) {
						swal({
							title: 'Invitations successfully sent',
							text: 'You have been redirected to Test Overview page.',
							type: 'success',
							showCancelButton: false,
							confirmButtonText: 'Close',
							confirmButtonColor: '#008fb3',
							allowOutsideClick: false,
							allowEscapeKey: false
						});

						this.backToOverview();
						return;
					}

					this.bulkSendingEmailProgress = 100;
					this.bulkInvitationsSendingInProgress = false;
				}
			);
	}

	public backToOverview() {
		this.bulkInvitationsSendingStarted = false;
		this.bulkInvitationsSendingInProgress = false;
		this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'changeView', data: 'summary' });
	}

	public close() {
		this.bulkInvitationsSendingStarted = false;
		this.bulkInvitationsSendingInProgress = false;
		this.tagifyCmp.addTags(this.bulkEmails.filter((email) => this.bulkEmailsFailedToSend.indexOf(email) > -1));
	}

	private createAndSendBulkTestLink(data) {
		return this.sharedHackService.postExternalTestsInvitation(String(this.authService.userId), this.test.id, {}, true)
			.switchMap((invite) => {
				this.screenTalentService.emitEventAction({ component: 'screen-talent', action: 'candidateInvited', data: false });
				data['message'] = replaceAll(data['message'], '{{invitation_link}}', invite.url);
				return this.sharedHackService.postExternalTestsInvitationNotification(String(this.authService.userId), invite.id, data, true).catch((err) => {
					this.onBulkSendErr(data.invited_email);
					return Observable.empty();
				});
			}).catch((err) => {
				this.onBulkSendErr(data.invited_email);
				return Observable.empty();
			});
	}

	private onBulkSendErr(email) {
		this.bulkSendingEmailProgress += this.bulkSendingEmailProgressStep;
		this.bulkEmailsFailedToSend.push(email);
	}

	// Helpers
	private setEmailTemplate(client: any): void {
		if (this.test.invite_email_subject) {
			this.emailInvitation['subject'] = this.bulkInvitationsActive ? replaceAll(this.test.invite_email_subject, '{{candidate_first_name}}', '') : this.test.invite_email_subject;
		}
		if (this.test.invite_email_template) {
			this.emailInvitation['message'] = this.bulkInvitationsActive ? replaceAll(this.test.invite_email_template, '{{candidate_first_name}}', '') : replaceAll(this.test.invite_email_template, '{{invitation_link}}', this.emailInvitation.testLink);
		} else {
			let message = `<p>Hi,</p>` +
				`<p>I would like to invite you to solve our <strong>${this.test.title}</strong> test on hackajob. <a href="${this.bulkInvitationsActive ? '{{invitation_link}}' : this.emailInvitation.testLink}">Follow this link</a> to get started.</p>` +
				`<p>Thank you,<br />` +
				`${client.contact_name}` + (client.contact_position ? ` @ ${client.contact_position}` : ``) + `<br />` +
				`${client.name}</p>`;

			if (this.test.type === 'remote-interview') {
				message = `<p>Hi,</p>` +
					`<p>I would like to invite you to our interview using the hackajob platform. <a href="${this.bulkInvitationsActive ? '{{invitation_link}}' : this.emailInvitation.testLink}">Follow this link</a> to join in the interview, use this link only when the interview is starting.</p>` +
					`<p>Thank you,<br />` +
					`${client.contact_name}` + (client.contact_position ? ` @ ${client.contact_position}` : ``) + `<br />` +
					`${client.name}</p>`;
			}
			this.emailInvitation['message'] = message;
		}
	}
static ctorParameters() { return [ { type: AuthService }, { type: SharedHackService }, { type: ScreenTalentService }, { type: SharedClientService } ]; }}

const replaceAll = (str: string, find: string, replaceWith: string) => {
	return str.replace(new RegExp(find, 'g'), replaceWith);
};



// WEBPACK FOOTER //
// ./node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/components/client/screen-talent/test/invite-candidate/invite-candidate.component.ts